import React from "react";
import DialogModal from "../../reusables/DialogModal";

const DeleteCompanyDialog = ({ isOpen, onClose, onConfirm }) => {
  return (
    <DialogModal isOpen={isOpen} onClose={onClose} title="Delete Company">
      <p className="text-sm text-gray-500">
        Are you sure you want to proceed?<br />
        This action will delete the entire company and all the users.
      </p>
      <div className="mt-6 flex justify-between gap-3">
        <button
          className="px-4 py-2 bg-gray-300 rounded"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          className="px-4 py-2 bg-customeOrange text-white rounded"
          onClick={onConfirm}
        >
          Confirm
        </button>
      </div>
    </DialogModal>
  );
};

export default DeleteCompanyDialog;